import React, { useEffect, useState } from "react";
import useAttendee from "containers/attendee/useHooks";
import useUtils from "hooks/useUtils";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { useSelector } from "react-redux";
import cogNotFoundGif from "assets/images/gifs/cog-not-found.gif";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";


const CupOfGratitude = ( ) => {
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [data, setData] = useState<[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const { getCupGradituteHostById } = useAttendee();
  
  useEffect(() => {
    const id = Number(params?.hostId);
    if (id) {
      const handleData = (response: any) => {
        setData(response || []);
        // Mark initial load as complete after first API call
        setIsInitialLoad(false);
      };
      getCupGradituteHostById(id, handleData);
    }
  }, [params?.id]);

  const groupedData = Object.values(
    data.reduce((acc: any, item: any) => {
      if (!acc[item.cogId]) {
        acc[item.cogId] = { ...item, totalPrice: item.price, count: 1 };
      } else {
        acc[item.cogId].totalPrice += item.price;
        acc[item.cogId].count += 1;
      }
      return acc;
    }, {})
  ); 

  return (
    <div className="">
      <h1 className="text-3xl font-medium text-blackie my-10">All ({data?.length})</h1>
      <div className="flex flex-wrap gap-6 items-center">
        {groupedData.map((cup: any) => (
          <div key={cup.cogId} className="relative text-center ">
            <img
              src={concatPathWithBackendUrl(cup.image?.fileDownloadUri)}
              alt={cup.title}
              className="w-[200px] h-[250px]"
            />
            {/* <span className="absolute top-12 right-[0px] -translate-x-1/2 -translate-y-1/2 bg-brown text-[#FFF0D8] text-[44px] font-bold">
              ${cup.price}
            </span> */}
            <h3 className="text-blackie text-4xl font-bold my-2">
              {cup.title}
            </h3>
            <div className="mx-auto w-fit mt-2">
              <p className="text-xs bg-yellowBg text-yellowText px-3 py-1 rounded-full">
                {cup.count} {cup.count > 1 ? "times" : "time"}
              </p>
            </div>
          </div>
        ))}

      </div>
      <div className="mt-10">
        <CustomMessageDisplay
          show={!isLoading && !data.length && !isInitialLoad}
          title="No Cups of Gratitude Available"
          slogan="This host hasn't received any cups of gratitude yet. Be the first to show appreciation!"
          image={cogNotFoundGif}
          imageAlt="No cups of gratitude found"
          className="py-12"
          imageClassName="w-[150px] h-[120px]"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      </div>
    </div>
  );
};

export default CupOfGratitude;
